import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { ProjectListCardComponent } from './project-list-card.component';
import { ProjectListCardService } from './project-list-card.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { OverduePipe } from './pipes/overdue.pipe';
import { ProjectStatusPipe } from './pipes/project-status.pipe';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { SendMessageDialogModule } from '../send-message-dialog/send-message-dialog.module';

@NgModule({
  declarations: [ProjectListCardComponent, OverduePipe, ProjectStatusPipe],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    MatCardModule,
    MatIconModule,
    MatDividerModule,
    MatChipsModule,
    GalaxyAvatarModule,
    GalaxyBadgeModule,
    MatProgressSpinnerModule,
    GalaxyLoadingSpinnerModule,
    GalaxyEmptyStateModule,
    MatListModule,
    MatButtonModule,
    GalaxyPipesModule,
    MatListModule,
    MatButtonModule,
    MatDialogModule,
    MatRadioModule,
    GalaxyFormFieldModule,
    SendMessageDialogModule,
  ],
  exports: [ProjectListCardComponent],
  providers: [ProjectListCardService, OverduePipe, ProjectStatusPipe],
})
export class ProjectListCardModule {}
